// extracted by mini-css-extract-plugin
module.exports =  {"container":"_32bbee5fda--container--qr6RQ","icon":"_32bbee5fda--icon--o1BXw"};